import { ComboboxItem, Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import OverlaySection from '@/components/OverlaySection.tsx';

import { insuranceType } from '@/constants/patient-data-form.constants.ts';

import { EnrichedDCConfig } from '@/models/EnrichedPrismicDocuments.ts';
import { EditPatientFormData, PatientFormData } from '@/models/Patient.ts';
import { PVSProvider } from '@/models/customers/PVSProvider.ts';

import FormSection from './FormSection.tsx';

interface Props {
    form: UseFormReturnType<PatientFormData | EditPatientFormData>;
    usedConfig: EnrichedDCConfig | undefined;
    practiceOptions: ComboboxItem[] | undefined;
}

export const PatientCostCarrierSection = ({ form, usedConfig, practiceOptions }: Props) => {
    return (
        <OverlaySection className="items-start gap-2">
            <FormSection
                classNames={{
                    title: 'pb-1 text-lg font-bold',
                    wrapper: 'w-full gap-y-3',
                    firstChild: 'flex-[0_0_100%]',
                }}
                title="Kostenträger"
            >
                <div className="flex w-full flex-wrap justify-between gap-2">
                    {usedConfig?.pvs_provider !== PVSProvider.DATA_CUR && (
                        <Select
                            className="flex-[0_0_49%]"
                            searchable
                            disabled={!practiceOptions?.length}
                            label="Betriebsstätte"
                            key={form.key('location_id')}
                            data={practiceOptions ?? []}
                            {...form.getInputProps('location_id')}
                            withAsterisk
                        />
                    )}
                    <Select
                        className="flex-[0_0_49%]"
                        label="Versicherungsart"
                        key={form.key('insurance_type')}
                        data={insuranceType}
                        searchable
                        allowDeselect={false}
                        {...form.getInputProps('insurance_type')}
                    />
                </div>
            </FormSection>
        </OverlaySection>
    );
};
